/* Fabriqué par shopify/native/construire.cjs depuis features/donnees : ne pas modifier ici. */
(function(){
function creerFormatTiki(IMAGES,LANGUE,DEVISE,TAUX,dictionnaires){
var MOTS_EURO=/\b(euros?|Euros?)\b/g;
function pts(centiemes) {
    return Math.round(Number(centiemes || 0) / 100).toLocaleString(LANGUE);
  }
function rond(v) {
    if (v <= 0) return 0;
    var pas = v < 20 ? 1 : 5;
    return Math.floor(v / pas) * pas;
  }
function euros(centiemes) {
    var v = Number(centiemes || 0) / 100 * TAUX;
    var decimales = 2;

    /* UN MONTANT CONVERTI S'ARRONDIT VERS LE BAS, JAMAIS VERS LE HAUT.
       Haïm Hamelekh, le 4 octobre 2026 : « 238,59 $, arrondis en dessous ».

       « 238,59 $ » était juste et illisible. Mais arrondir au plus proche aurait
       donné « 11 $ » pour une remise de 10,80 $, et une cliente qui lit 11 et
       qui en obtient 10,80 écrit au service client. Vers le bas, l'écart joue
       toujours en sa faveur : elle lit 10 $, elle en reçoit 10,80.

       On n'arrondit QUE ce qui a été converti. En euros, le montant est le vrai,
       au centime près, et « 24,50 € » doit rester « 24,50 € ». */
    if (TAUX !== 1) { v = rond(v); decimales = 0; }
    else if (Math.abs(v - Math.round(v)) < 0.005) { decimales = 0; }

    try {
      return v.toLocaleString(LANGUE, { style: 'currency', currency: DEVISE,
                                        maximumFractionDigits: decimales });
    } catch (e) {
      return (decimales ? v.toFixed(2).replace('.', ',') : String(v)) + ' ' + DEVISE;
    }
  }
function image(chemin, taille) {
    if (!chemin) return '';
    if (/^https?:/.test(chemin)) return chemin;
    return IMAGES + '/' + (taille || 128) + '/' + chemin.replace(/\.(png|jpe?g|webp)$/i, '.webp');
  }
function mot(cle, valeurs) {
    var m = (dictionnaires.mots() && dictionnaires.mots()[cle]) || cle;
    if (valeurs) {
      for (var k in valeurs) {
        if (Object.prototype.hasOwnProperty.call(valeurs, k)) {
          m = m.split('[' + k + ']').join(valeurs[k]);
        }
      }
    }
    return adapter(m);
  }
function montantConverti(brut) {
    // « 1 000 », « 1,000 », « 2.500 », « 5 » : les quatre langues n'écrivent pas
    // les milliers pareil, et se tromper de séparateur ferait d'un montant de
    // 2 500 € un montant de 2,50 €.
    var net = brut.replace(/[\s  ]/g, '');
    var n;
    if (/^\d{1,3}([.,]\d{3})+$/.test(net)) n = Number(net.replace(/[.,]/g, ''));
    else if (/^\d+[.,]\d{1,2}$/.test(net)) n = Number(net.replace(',', '.'));
    else n = Number(net.replace(/[.,]/g, ''));
    if (!isFinite(n)) return null;
    return euros(Math.round(n * 100));   // `euros` convertit et arrondit en dessous
  }
function adapter(s) {
    if (TAUX === 1 || s == null) return s;
    var t = String(s).replace(/(\d[\d\s  .,]*\d|\d)\s*€/g, function (tout, nombre) {
      var m = montantConverti(nombre);
      return m == null ? tout : m;
    });
    // « 15-€-Geschenkkarte » : l'allemand colle le symbole au mot avec des
    // traits d'union, et le motif ci-dessus l'a déjà traité. Reste le mot.
    var nom = (dictionnaires.mots() && dictionnaires.mots()['devise_' + DEVISE]) || '';
    if (nom) t = t.replace(MOTS_EURO, nom);
    return t;
  }
function phrase(fr) {
    if (fr == null) return '';
    var p = dictionnaires.phrases();
    return adapter((p && p[fr]) || fr);
  }
return {pts:pts,rond:rond,euros:euros,image:image,mot:mot,montantConverti:montantConverti,adapter:adapter,phrase:phrase};
}

function creerFicheTiki(transport){
var fiche=null,demande=null;
function charger(encore) {
    if (encore) { fiche = null; demande = null; }
    if (fiche) return Promise.resolve(fiche);
    if (demande) return demande;
    demande = transport.charger()
      .then(function (d) { fiche = d; demande = null; return d; });
    return demande;
  }
return {charger:charger,fiche:function(){return fiche;}};
}

function creerTransportFiche(ADRESSE,fetch){return {charger:function(){return fetch(ADRESSE,{headers:{accept:'application/json'},credentials:'same-origin'})
.then(function(r){return r.json().catch(function(){return {erreur:'reponse illisible'};});})
.catch(function(){return {erreur:'injoignable'};});}};}

function creerAffichageTiki(document,format){
var image=format.image;
function texte(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
function imageBadge(chemin, taille, alt) {
    if (!chemin) return '';
    return '<img src="' + image(chemin, taille) + '" alt="' + texte(alt || '') + '" loading="lazy"' +
           ' onerror="var t=this.closest(\'[data-tuile]\');' +
           ' if(t){t.hidden=true}else{this.remove()}">';
  }
return {texte:texte,imageBadge:imageBadge};
}

(function () {
  'use strict';
  // Rendu deux fois dans la même page (le pop-up ET la page du club) : la
  // deuxième fois ne doit rien refaire, surtout pas repartir chercher la fiche.
  if (window.TikiDonnees) return;

  var ADRESSE = '/apps/tiki-club';
  // (8 octobre 2026) ce code est un fichier du thème, gardé par le navigateur : les valeurs propres
  // à la page (adresses, cliente connectée, devise) sont posées juste avant par `oraloa-tiki-donnees`.
  var R = window.TikiReglages || {};
  var IMAGES  = R.images;
  var PAGE    = R.page;
  var LANGUE  = document.documentElement.lang || 'fr';
  var CONNECTE = R.connectee === true;






  /* ── LA DEVISE EST CELLE DE LA CLIENTE, PAS LA NÔTRE ──────────────────────
     4 octobre 2026. Haïm Hamelekh : « le Tiki Club doit afficher la devise que
     le client utilise ».

     Une Américaine qui voit tout son site en dollars lisait « 221 € de remise
     disponibles ». Elle devait convertir de tête pour savoir ce que valaient
     ses points, et une remise qu'on doit convertir de tête n'est pas une
     récompense, c'est un calcul.

     D'OÙ VIENT LE TAUX. De Shopify, et de nulle part ailleurs. `Shopify.currency`
     est posé sur toutes les pages d'une boutique : `active` est la devise
     affichée, `rate` le taux depuis la devise de la boutique (l'euro chez
     Oraloa). C'est EXACTEMENT le taux que Shopify appliquera à la caisse : si
     nous en prenions un autre, le montant annoncé ici et le montant retiré
     là-bas ne seraient pas les mêmes, et c'est de l'argent.

     LES POINTS, EUX, NE SE CONVERTISSENT PAS. Un point est un point partout.
     Seule leur valeur en argent change d'habit. */
  var DEVISE = R.devise || 'EUR';
  var TAUX = 1;
  try {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      DEVISE = window.Shopify.currency.active;
      TAUX = Number(window.Shopify.currency.rate) || 1;
    }
  } catch (e) { /* on reste dans la devise de la boutique */ }

  /* UN MONTANT CONVERTI SE POSE SUR UN CHIFFRE ROND, ET TOUJOURS EN DESSOUS.
     Haïm Hamelekh, le 4 octobre 2026, devant sa page en shekels : « peu importe
     la devise, les sommes doivent être des montants fixes ».

     Il avait raison, et c'était laid : « 35,18 ₪ », « 87,94 ₪ », « 527,65 ₪ ».
     Six récompenses, six nombres à virgule, et l'échelle ne ressemblait plus à
     une échelle. Une remise se lit d'un coup d'œil ou elle ne se lit pas.

     On descend donc au multiple de cinq en dessous (de un, pour les petites
     sommes, sinon « 7 » deviendrait « 5 »). TOUJOURS EN DESSOUS, jamais
     au-dessus : l'écart joue en sa faveur, elle lit 85 et elle obtient 87,94.
     L'inverse ferait écrire au service client, et aurait raison de le faire. */






  // « medaillons/bienvenue.png » → la vignette allégée, en 128 ou 256 pixels.
  // Une adresse complète (une image déjà hébergée ailleurs) passe telle quelle.


  /**
   * Ce que le serveur a à dire sur la personne qui regarde.
   *
   * Pour une membre : son solde, son niveau, ses badges. Pour tous les autres,
   * connectés ou non : le CATALOGUE, c'est-à-dire les niveaux, les récompenses
   * et les 74 badges, sans aucune donnée personnelle. La demande vaut donc le
   * coup dans les deux cas, et c'est elle qui permet à la page du Tiki Club de
   * donner envie à quelqu'un qui n'en fait pas encore partie.
   *
   * Une seule demande par visite, même si le pop-up et la page la réclament
   * tous les deux : la deuxième attend la première au lieu d'en lancer une autre.
   */
  // `charger(true)` : redemander la fiche parce qu'elle vient de changer. Un
  // échange de points modifie le solde, les récompenses disponibles et la liste
  // des bons ; recalculer tout cela dans la page donnerait un écran qui ment dès
  // qu'une règle bouge. On redemande, et le serveur tranche.


  /**
   * Un mot du Tiki Club, dans la langue que la cliente voit.
   *
   *     mot('encore_pts', { n: '240' })   →  « encore 240 pts »
   *     mot('avis_titre')                 →  « Les avis de nos créatifs »
   *
   * Les nombres ne sont jamais dans le dictionnaire : ils viennent remplacer
   * `[n]`, `[a]`, `[b]`… Une phrase coupée en deux morceaux autour d'un nombre
   * ne se traduit pas, parce que l'allemand et l'espagnol ne mettent pas les
   * mots dans le même ordre que le français.
   *
   * Les valeurs passées ici sont déjà des nombres mis en forme par `pts` ou
   * `euros`, ou du texte passé par `texte()`. Rien d'autre n'entre.
   *
   * Clé inconnue → la clé elle-même. On voit tout de suite laquelle manque, et
   * la page ne casse pas pour autant.
   */


  /* ═══════ LES PHRASES AUSSI PARLENT SA DEVISE ═══════

     « Il faut bien comprendre que TOUT doit être adapté en USD. »

     Convertir le solde ne suffisait pas : la page continuait d'annoncer
     « 5 points par euro de kits », « 250 € de kits au total », « carte cadeau
     de 15 € offerte » à une cliente qui n'a jamais vu un euro de sa vie. Un
     écran à moitié converti est pire qu'un écran qui ne l'est pas : il donne
     l'impression qu'on s'est trompé quelque part.

     DEUX CHOSES À REMPLACER, ET RIEN D'AUTRE :
       · les montants (« 250 € » devient « $270 ») ;
       · le mot « euro » lui-même (« par euro » devient « par dollar »), pris
         dans le carnet des quatre langues, jamais écrit en dur ici.

     ON NE TOUCHE À RIEN EN EUROS. Sur la page française en euros, le taux vaut
     un, et cette fonction rend la phrase telle qu'elle est arrivée. */






  /**
   * Une phrase venue de la BASE, dans la langue que la cliente voit.
   *
   *     phrase('5 points par euro de kits')  →  « 5 Punkte pro Euro für Sets »
   *
   * Les avantages des niveaux, les familles de badges et les conditions sont
   * écrits en français dans la base. Le carnet de `oraloa-tiki-mots` les
   * traduit, et **ce qu'il ne connaît pas ressort en français**, jamais faux.
   *
   * Un texte qui change dans la base sort donc du carnet tout seul : la
   * traduction cesse de s'appliquer au lieu de dire autre chose que l'original.
   */


  /**
   * La balise image d'un badge, qui s'efface si le dessin n'existe pas encore.
   *
   * POURQUOI
   * ────────
   * Le catalogue compte des badges que Haïm Hamelekh n'a pas encore dessinés :
   * vingt sur soixante-quatorze au 2 octobre 2026 (les jeux, le parrainage, les
   * défis des mois à venir). Leur médaillon n'est pas dans le stockage, et le
   * navigateur affichait un cadre vide avec l'icône d'image cassée, sur la page
   * publique du programme.
   *
   * On ne dessine pas à sa place : la tuile entière disparaît tant que l'image
   * manque, et **elle revient toute seule** le jour où le dessin est publié.
   * Rien à changer dans le code ce jour-là, rien à se rappeler.
   *
   * `data-tuile` dit quel morceau cacher : sans lui, seule l'image s'enlève,
   * et il resterait un nom de badge sans médaillon.
   */


  var format=creerFormatTiki(IMAGES,LANGUE,typeof DEVISE==='undefined'?'EUR':DEVISE,typeof TAUX==='undefined'?1:TAUX,{mots:function(){return window.TikiMots;},phrases:function(){return window.TikiPhrases;}});
  var affichage=creerAffichageTiki(document,format);
  var modeleFiche=creerFicheTiki(creerTransportFiche(ADRESSE,function(url,options){return fetch(url,options);}));
  var pts=format.pts;
  var rond=format.rond;
  var euros=format.euros;
  var image=format.image;
  var mot=format.mot;
  var montantConverti=format.montantConverti;
  var adapter=format.adapter;
  var phrase=format.phrase;
  var texte=affichage.texte,imageBadge=affichage.imageBadge,charger=modeleFiche.charger;
  window.TikiDonnees = {
    charger: charger,
    fiche: modeleFiche.fiche,
    connectee: CONNECTE,
    pts: pts, euros: euros, texte: texte, image: image, imageBadge: imageBadge, mot: mot, phrase: phrase,
    liens: { page: PAGE, badges: PAGE + '#badges', echanger: PAGE + '#echanger',
             compte: "/pages/mon-compte", connexion: R.connexion,
             // L'inscription : son adresse change avec la langue et avec les
             // comptes clients de la boutique. On la demande à Shopify.
             inscription: R.inscription }
  };
})();
})();
